var WarrantyStatusBadgeModule = /** @class */ (function () {
    function WarrantyStatusBadgeModule() {
    }
    return WarrantyStatusBadgeModule;
}());
export { WarrantyStatusBadgeModule };
